import React, { useEffect, useState } from 'react';

import { useHistory } from  "react-router-dom";

import ChangePassword from './ChangePassword.js';


/*
Wraps ChangePassword with routing behavior
 */
const RoutingChangePassword = ({
	showInfo,
}) => {

	const history = useHistory();

	const cancel = () => history.push('/');



	// render

	return (
		<ChangePassword
			cancel = {cancel}
			showInfo = {showInfo}/>
	);
}

export default RoutingChangePassword;
